import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import moment from 'moment';

//reemplazando valores de iniciales en estado

export default function ModalMark(props) {
  const holiday = props.model;

  return (
    <Modal
      title="Feriado"
      model={holiday}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/holiday"
      state
    >
      <TextField
        label="Fecha"
        type="date"
        name="day"
        margin="normal"
        fullWidth
        InputLabelProps={{
          shrink: true
        }}
        defaultValue={
          !!holiday ? holiday.day || moment().format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        }
        required
      />
      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={!!holiday ? holiday.description : ''}
        required
      />
    </Modal>
  );
}
